import React from 'react';
import { useTranslate } from '@tolgee/react';
import DatePicker from '../../components/datePicker';
import { LomavisH2 } from '@/lomavisSharedUi/atoms/typography/LomavisH2';
import NewPlotTabs from '../../components/plotTabs/newPlotTabs';
import { DataTableComp } from '../../components/dataTable';
import { getAllDates } from '../../utils/dateUtils';

interface GrowthTabProps {
  dates: any;
  setDates: (dates: any) => void;
  plotsData: any;
  loading: boolean;
  error: boolean;
  show_data_import_info: boolean;
  locationslug: string;
  activeConfigMap: any;
}

const GrowthTab: React.FC<GrowthTabProps> = ({
  dates,
  setDates,
  plotsData,
  loading,
  error,
  show_data_import_info,
  locationslug,
  activeConfigMap
}) => {
  const { t } = useTranslate();

  return (
    <div>
      <div className="d-flex flex-column flex-lg-row justify-content-lg-end">
        <DatePicker setDates={setDates} dates={dates} />
      </div>
      <div className="m-5" />
      <div className="m-5" />
      <LomavisH2 title={t('platform_analytics.title.PlotSection')} />
      <div className={'mb-5'} />

      <NewPlotTabs
        labelsLength={
          getAllDates(dates.startDate, dates.endDate).length
        }
        sync={show_data_import_info}
        data={plotsData}
        config={activeConfigMap}
        display={true}
        hasError={error}
        isLoading={loading}
      />

      <DataTableComp location={locationslug} />
      <div className="m-2" />
    </div>
  );
};

export default GrowthTab;